// src/data/hotelData.js

export const bookingLink = "https://live.ipms247.com/booking/book-rooms-miranhotelssuites";
export const whatsappConfig = {
  number: "+919266134138", // Format: CountryCode + Number (No + or -)
  message: "Hello, I am interested in booking a suite at Miran Suites."
};
export const rooms = [
  {
    id: 'deluxe',
    title: 'Deluxe Room',
    description: 'A perfect blend of comfort and style for the modern traveler.',
    price: '₹3500',
    size: '350 sq ft',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/Rooms%20Page%2FDeluxe%2Fdeluxe-room-01.jpg?alt=media&token=beb5ea5c-f99d-479d-99b5-3f45f1027e23',
      'https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/Rooms%20Page%2FDeluxe%2Fdeluxe-room-02.jpg?alt=media&token=58d08719-e53b-4678-93ad-8a5ddc9c033f',
    'https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/Rooms%20Page%2FDeluxe%2Fdeluxe-room-03.jpg?alt=media&token=e6d95f7e-a0d7-4cd4-9637-082d5f66e3fb',
    'https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/Rooms%20Page%2FDeluxe%2Fdeluxe-room-04.jpg?alt=media&token=dd9b9733-991a-4d29-8432-b241faf175e3',
    'https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/Rooms%20Page%2FDeluxe%2Fdeluxe-room-05.jpg?alt=media&token=3f575460-7b9f-46a1-b9c2-f42beb183429',
    'https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/Rooms%20Page%2FDeluxe%2Fdeluxe-room-06.jpg?alt=media&token=3fe2f2f0-c578-4141-b8bc-f94bc8ad12d8',
    'https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/Rooms%20Page%2FDeluxe%2Fdeluxe-room-07.jpg?alt=media&token=aa16d646-44cb-478a-9caa-6bb7f19c869b',
    'https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/Rooms%20Page%2FDeluxe%2Fdeluxe-room-08.jpg?alt=media&token=57d1f044-5245-4e07-b271-1e35e553d1fd',
    'https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/Rooms%20Page%2FDeluxe%2Fdeluxe-room-09.jpg?alt=media&token=bba863b3-3743-437d-92c6-75e07b19ca44',
    'https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/Rooms%20Page%2FDeluxe%2Fdeluxe-room-10.jpg?alt=media&token=1cd26b61-a89c-469d-8fd3-c6b130c45cb2',
    'https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/Rooms%20Page%2FDeluxe%2Fdeluxe-room-bathroom-01.jpg?alt=media&token=3b63349d-2602-44b6-bdea-9b58b44c8534',
    'https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/Rooms%20Page%2FDeluxe%2Fdeluxe-room-bathroom-02.jpg?alt=media&token=8b8a68da-426e-40cb-8152-d2b14eff63a9',

    ],
    amenities: ['King Bed', 'City View', 'Rain Shower', 'Free Wi-Fi']
  },
  {
    id: 'premium',
    title: 'Premium Room',
    description: 'Elevated luxury with additional living space and premium amenities.',
    price: '₹4500',
    size: '450 sq ft',
    images: [
      'https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/Rooms%20Page%2FPremium%2Fpremium-room-with-living-area-01.jpg?alt=media&token=28079b90-9cbb-41fa-ae8b-80dc9f981467',
      'https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/Rooms%20Page%2FPremium%2Fpremium-room-with-living-area-02.jpg?alt=media&token=1cdbf159-c9df-4ef7-b407-e8094f2be312',
      'https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/Rooms%20Page%2FPremium%2Fpremium-room-with-living-area-03.jpg?alt=media&token=e53f1c47-322c-4035-b889-43323d0166f8',
      'https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/Rooms%20Page%2FPremium%2Fpremium-room-with-living-area-04.jpg?alt=media&token=62a1ec78-e27e-4381-8ede-bc88fd1f29ca',
      'https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/Rooms%20Page%2FPremium%2Fpremium-room-with-living-area-05.jpg?alt=media&token=32777695-5dc0-47e2-9d4b-4584284f3fb3',
      'https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/Rooms%20Page%2FPremium%2Fpremium-room-with-living-area-06.jpg?alt=media&token=ec3b5043-1303-415d-a5b5-7795d19dd995',
      'https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/Rooms%20Page%2FPremium%2Fpremium-room-with-living-area-07.jpg?alt=media&token=fb900bd7-f153-4194-b83d-d0d6dfc09f6e',
      'https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/Rooms%20Page%2FPremium%2Fpremium-room-with-living-area-08.jpg?alt=media&token=7665f4b4-3bb7-4f1c-ad14-8528a781ff92',
      'https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/Rooms%20Page%2FPremium%2Fpremium-room-bathroom-01.jpg?alt=media&token=ae98b45a-ae7b-48fd-94e8-ee5700f87a00',
      'https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/Rooms%20Page%2FPremium%2Fpremium-room-bathroom-02.jpg?alt=media&token=93128631-faf7-4648-97d4-af48bc273fa6',
      'https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/Rooms%20Page%2FPremium%2Fpremium-room-bathroom-03.jpg?alt=media&token=eb177fb7-d8f9-45e1-ab51-a2105c4c6211',  
    ],
    amenities: ['King Bed', 'Ocean View', 'Bathtub', 'Mini Bar']
  },
  {
    id: 'studio',
    title: 'Studio Suite',
    description: 'Spacious open-plan suite designed for extended stays and relaxation.',
    price: '₹5500',
    size: '600 sq ft',
    images: [
      'https://placehold.co/800x500/c7c7c7/333?text=Studio+Suite+1',
      'https://placehold.co/800x500/c7c7c7/333?text=Studio+Bath'
    ],
    amenities: ['Living Area', 'Kitchenette', 'Walk-in Closet', 'Workspace']
  },
  {
    id: 'presidential',
    title: 'Presidential Suite',
    description: 'The pinnacle of luxury at Miran Suites. Unmatched elegance.',
    price: '₹7500',
    size: '1200 sq ft',
    images: [
      'https://placehold.co/800x500/b0b0b0/333?text=Presidential+Living',
      'https://placehold.co/800x500/b0b0b0/333?text=Presidential+Bedroom'
    ],
    amenities: ['2 Bedrooms', 'Private Terrace', 'Jacuzzi', 'Butler Service']
  },
];



export const homePage = {
    "HeroSlide1" : "https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/Home%20Page%2Freception-01.jpg?alt=media&token=397732b2-b5cd-41dc-a7b8-0ded5f5dde8f",
    "HeroSlide2" : "https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/Home%20Page%2Ffacade-night-02.jpg?alt=media&token=56ecd0b2-e58a-4dcf-99c9-f18839bc365f",
    "Intro" : "https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/Home%20Page%2Fpremium-room-with-living-area-01.jpg?alt=media&token=5d3ac3d4-6700-4bb7-8420-282703348f3f",

}


export const aboutPage = {
  banner: "https://firebasestorage.googleapis.com/v0/b/miran-suites.firebasestorage.app/o/About%20Us%20Page%2Freception-06.jpg?alt=media&token=a9a9dac4-f3d4-4b66-b1ad-26c61b807458",
  stats: [
    { label: "Guest Satisfaction", value: "98%" },
    { label: "Luxury Suites", value: "45+" },
    { label: "Years of Service", value: "12" },
    { label: "Global Awards", value: "05" }
  ],
  tiles: [
    {
      id: 1,
      title: "Design Philosophy",
      text: "Where contemporary aesthetics meet timeless classical touches.",
      image: "https://placehold.co/600x600/222/d4af37?text=Architecture",
      dark: true
    },
    {
      id: 2,
      title: "Culinary Excellence",
      text: "Flavors curated for the global palate.",
      image: "https://placehold.co/600x600/eee/333?text=Dining",
      dark: false
    },
    {
      id: 3,
      title: "Wellness & Spa",
      text: "Rejuvenate in our sanctuary of calm.",
      image: "https://placehold.co/600x600/333/fff?text=Wellness",
      dark: true
    },
    {
      id: 4,
      title: "Concierge",
      text: "Service that anticipates your every need.",
      image: "https://placehold.co/600x600/fff/333?text=Service",
      dark: false
    }
  ]
};